import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

export const ICON = {
    delete: "delete",
    toTop: "toTop",
    edit: "edit",
    close: "close",
    eye: "eye",
    eyeInvisible: "eyeInvisible",
    update: "update",
};

export interface IconButtonProps {
  children?: React.ReactNode;
  icon: string;
  transparent?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const IconButton = ({ children, icon, transparent, ...props }: IconButtonProps) => (
    <button
        type="button"
        className={cn(styles.button, styles[`button__${ICON[icon]}`], {
            [styles.button__transparent]: transparent,
        })}
        {...props}
    >
        {children}
    </button>
);

export default IconButton;
